import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { Checkbox, Table } from 'hljd'
import columns from './columns'
import { toJS } from 'mobx'
const CheckboxGroup = Checkbox.Group
@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const {
      options,
      checkedList,
      checkAll,
      onChange,
      onCheckAllChange,
      score,
      userRange,
      selectedRowKeys,
      paginationChange,
      pagination,
      limitCount,
      loading
    } = store
    return (
      <Fragment>
        <Fragment>
          <Checkbox
            onChange={onCheckAllChange}
            checked={checkAll}
            disabled={checkAll}
          >
            全部
          </Checkbox>
          <CheckboxGroup
            options={toJS(options)}
            value={toJS(checkedList)}
            onChange={onChange}
          />
        </Fragment>
        <div style={{ color: '#333', fontSize: 14, margin: '14px 0 9px' }}>
          选中{selectedRowKeys.length}人
          {userRange.length > 0 &&
            limitCount > score && (
              <span style={{ color: '#f83244' }}>
                （仅剩余点数{score}个，默认选中前{score}个客资）
              </span>
            )}
          {userRange.length > 0 &&
            selectedRowKeys.length == 300 && (
              <span style={{ color: '#f83244' }}>
                （一次发送最多选择{limitCount}个潜在客资）
              </span>
            )}
        </div>
        <Table
          rowKey={record => record.id}
          dataSource={toJS(userRange)}
          columns={columns}
          selectabled
          rowSelection={{
            onChange: store.onSelectChange,
            selectedRowKeys: store.selectedRowKeys,
            onSelectAll: store.onSelectAll
          }}
          pagination={pagination}
          onChange={paginationChange}
          scroll={{ y: 400 }}
          loading={loading}
        />
      </Fragment>
    )
  }
}
